import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.surfaceFeatures.query.gql"
import type {
  FeatureSurfaceFeaturesQuery,
  FeatureSurfaceFeaturesQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/compose/__types__/license.featureGroup.surfaceFeatures.query"

type Options = QueryHookOptions<
  FeatureSurfaceFeaturesQuery,
  FeatureSurfaceFeaturesQueryVariables
>

export function useFeatureSurfaceFeaturesQuery(options: Options) {
  return useQuery<
    FeatureSurfaceFeaturesQuery,
    FeatureSurfaceFeaturesQueryVariables
  >(query, options)
}
